import type {
  IdleTaskHandle,
} from './types/run-when-idle-types';


const NOOP_IDLE_TASK: IdleTaskHandle = {
  cancel: () => undefined,
};

export function runWhenIdle(callback: () => void, timeoutMs = 2000): IdleTaskHandle {
  if (typeof window === 'undefined') return NOOP_IDLE_TASK;

  if (typeof window.requestIdleCallback === 'function') {
    const handle = window.requestIdleCallback(() => callback(), { timeout: timeoutMs });
    return {
      cancel: () => window.cancelIdleCallback(handle),
    };
  }

  const timeoutHandle = window.setTimeout(callback, 50);
  return {
    cancel: () => window.clearTimeout(timeoutHandle),
  };
}
